export default {"src":"/_next/static/media/g.119db903.svg","height":19,"width":19};